import KudosLogo from '@assets/images/KudosLogo.svg'
import AppPaths from '@globals/paths'
import { useTenantMetadata } from '@globals/useTenantMetadata'
import { MediaObjectUrl, MediaVariantEnum } from '@kudos/http-client'
import Box from '@mui/material/Box'
import MediaImage from '@shared/components/MediaImage'
import useMediaUrl from '@shared/hooks/useMediaUrl'
import { FC } from 'react'
import { Link as RouterLink } from 'react-router'

export const TENANT_LOGO_WIDTH = 264
export const TENANT_LOGO_HEIGHT = 52

type TenantLogoProps = {
  logoMediaUrls?: MediaObjectUrl
}
export const TenantLogo: FC<TenantLogoProps> = ({ logoMediaUrls }) => {
  const [metadata] = useTenantMetadata()
  const mediaUrls = logoMediaUrls === undefined ? metadata.logoUrls : logoMediaUrls
  const { url: logoUrl } = useMediaUrl(mediaUrls, MediaVariantEnum.LOGO)
  return (
    <Box
      maxWidth={TENANT_LOGO_WIDTH}
      maxHeight={TENANT_LOGO_HEIGHT}
      component={RouterLink}
      to={AppPaths.tenant.home()}>
      <MediaImage
        alt={metadata.name}
        imgSrc={logoUrl || KudosLogo}
        mediaUrls={mediaUrls}
        maxWidth={TENANT_LOGO_WIDTH}
        maxHeight={TENANT_LOGO_HEIGHT}
        height={TENANT_LOGO_HEIGHT}
        objectFit="contain"
        backgroundColor="transparent"
        eager
      />
    </Box>
  )
}

export default TenantLogo
